import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO56 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK005-6.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO56
